function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $uniUP } from "../..";
import angular from "angular";
var SidebarTooltipClickController = /*#__PURE__*/function () {
  SidebarTooltipClickController.$inject = ["$element", "$timeout", "$window", "$log"];
  function SidebarTooltipClickController($element, $timeout, $window, $log) {
    _classCallCheck(this, SidebarTooltipClickController);
    this.$element = $element;
    this.$timeout = $timeout;
    this.$window = $window;
    this.$log = $log;
  }
  return _createClass(SidebarTooltipClickController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$log.info("Instanciando sidebar tooltip click", this.title);
      this.$anchor = this.$element.find("span");
      this.$anchor.on("click", {}, function ($ev) {
        _this.$log.info("Binding", _this);
        angular.bind(_this, _this.crearTippy, $ev)();
      });
    }
  }, {
    key: "crearTippy",
    value: function crearTippy($event) {
      this.$log.info("Creando tippy sidebar tooltip click", this.title);
      var title = this.title || this.$anchor.attr("title") || this.$anchor.attr("title-dev");

      // toggle json-formatter si existe
      this.$code = this.$code || this.$element.find(".json-formatter-container");
      this.$code.toggleClass("ng-hide");
      if (true) return;
      if (false && !title) return;
      this.$window.tippy(this.$anchor[0], {
        content: title,
        allowHTML: true,
        arrow: true,
        trigger: "click",
        theme: "tip-json",
        // placement: "right",
        popperOptions: {
          modifiers: {
            preventOverflow: {
              boundariesElement: "window"
            }
          }
        }
      });
    }
  }]);
}();
/**
 * Panel lateral de acceso rápido a los tipos de catálogo
 */
$uniUP.component("sidebarTooltipClick", {
  bindings: {
    title: "@"
  },
  controller: SidebarTooltipClickController
  // transclude: true,
  // template : "<ng-transclude></ng-transclude>"
});